import { configureStore } from '@reduxjs/toolkit';
import notificationsReducer from './slices/notificationsSlice';
import chatReducer from './slices/ChatSlice';
import welcomeChain from "./slices/WelcomeChain";


export const store = configureStore({
    reducer: {
        notifications: notificationsReducer,
        chat: chatReducer,
        welcomeChain: welcomeChain
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;